import { encryptMessage, encryptLargeData } from "./rsa"
import axios from "axios"
import { host } from "../helper/config";

// Encode a Unicode string to Base64
const unicodeToBase64 = (str) => {
    // Encode the string as UTF-8
    let encoder = new TextEncoder();
    let utf8Array = encoder.encode(str);

    // Convert the Uint8Array to a string of binary data
    let binaryString = String.fromCharCode.apply(null, utf8Array);

    // Encode the binary string to Base64
    return btoa(binaryString);
}

// Decode a Base64 string to a Unicode string
const base64ToUnicode = (base64) => {
    // Decode the Base64 string to a binary string
    let binaryString = atob(base64);

    // Convert the binary string to a Uint8Array
    let binaryArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        binaryArray[i] = binaryString.charCodeAt(i);
    }

    // Decode the Uint8Array as UTF-8
    let decoder = new TextDecoder();
    return decoder.decode(binaryArray);
}

// // Example usage:
// let unicodeString = "你好，世界!";
// let base64String = unicodeToBase64(unicodeString);
// console.log(base64String);

// let decodedString = base64ToUnicode(base64String);
// console.log(decodedString);

export const getApi = async (token, code, data) => {
    const json = JSON.stringify(data)
    const d = unicodeToBase64(json)
    const url = `${host}/adminv2/get?${data ? 'data=' + d : ''}`

    const signing = encryptMessage(d)

    const response = await axios.get(
        url,
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token,
                "api-code": code,
                'api-signing': signing
            },
        }
    )

    if (response && response.status === 200 && response.data.error === 0) {
        return response.data.data
    }
    return undefined
}

export const postApi = async (token, code, data) => {
    const json = JSON.stringify(data)
    const d = unicodeToBase64(json)
    const url = `${host}/adminv2/post`

    const encrypted = encryptLargeData(d)

    const response = await axios.post(
        url,
        {
            data: d
        },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token,
                "api-code": code,
                'api-signing': encrypted.encryptedData,
                'api-aes-key': encrypted.encryptedAESKey,
                'api-aes-iv': encrypted.iv
            },
        }
    )

    if (response && response.status === 200 && response.data.error === 0) {
        return true
    }
    return false
}

export const postWithoutApi = async (code, data) => {
    const json = JSON.stringify(data)
    const d = unicodeToBase64(json)
    const url = `${host}/admin/post`

    const encrypted = encryptLargeData(d)

    const response = await axios.post(
        url,
        {
            data: d
        },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                "api-code": code,
                'api-signing': encrypted.encryptedData,
                'api-aes-key': encrypted.encryptedAESKey,
                'api-aes-iv': encrypted.iv
            },
        }
    )

    if (response && response.status === 200 && response.data.error === 0) {
        return true
    }
    return false
}